<template>
	<div class="addressContainer">
        <div class="boxTitle" v-if="label">{{label}}</div>
        <div class="row">
            <div class="col-sm-12" v-if="!readonly">
                <google-autocomplete v-model="googleAddress"></google-autocomplete>
            </div>
            <div class="form-group col-sm-10">
                <label>Via <span class="text-danger" v-if="showAsterisks">*</span></label>
                <span class="form-control" v-if="readonly">{{localValue.street || '-'}}</span>
                <input v-else class="form-control" v-model="localValue.street" />
            </div>
            <div class="form-group col-sm-2">
                <label>Civico <span class="text-danger" v-if="showAsterisks">*</span></label>
                <span class="form-control" v-if="readonly">{{localValue.streetNumber || '-'}}</span>
                <input v-else class="form-control" v-model="localValue.streetNumber" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-4">
                <label>Città <span class="text-danger" v-if="showAsterisks">*</span></label>
                <span class="form-control" v-if="readonly">{{localValue.city || '-'}}</span>
                <input v-else class="form-control" v-model="localValue.city" />
            </div>
            <div class="form-group col-md-4">
                <label>Regione</label>
                <span class="form-control" v-if="readonly">{{localValue.region || '-'}}</span>
                <input v-else class="form-control" v-model="localValue.region" />
            </div>
            <div class="form-group col-md-4">
                <label>Nazione <span class="text-danger" v-if="showAsterisks">*</span></label>
                <span class="form-control" v-if="readonly">{{localValue.country || '-'}}</span>
                <input v-else class="form-control" v-model="localValue.country" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-8">
                <label>Provincia <span class="text-danger" v-if="showAsterisks">*</span></label>
                <span class="form-control" v-if="readonly">{{localValue.province || '-'}}</span>
                <input v-else class="form-control" v-model="localValue.province" />
            </div>
            <div class="form-group col-4">
                <label>CAP <span class="text-danger" v-if="showAsterisks">*</span></label>
                <span class="form-control" v-if="readonly">{{localValue.postalCode || '-'}}</span>
                <input v-else class="form-control" v-model="localValue.postalCode" />
            </div>
        </div>
        <div class="form-group">
            <label>Scala, piano, interno ecc.</label>
            <span class="form-control" v-if="readonly">{{localValue.addressDetails || '-'}}</span>
            <input v-else class="form-control" v-model="localValue.addressDetails" />
        </div>
        <div class="form-group">
            <label>Note di contatto</label>
            <span class="form-control" v-if="readonly">{{localValue.notes || '-'}}</span>
            <input v-else class="form-control" v-model="localValue.notes" />
        </div>
	</div>
</template>

<script lang="ts">
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';

@Options({})
export default class opAddress extends mixins(WithModel) {

    @Prop({
        default: false
    }) readonly: boolean;
    @Prop() label: string;
    
    @Prop({
        default: false
    }) showAsterisks: boolean;

    googleAddress: any = null;
    declare localValue: OM.Address;

    created(){
        this.googleAddress = this.localValue.typedAddress;
    }

    onModelValueChange(next, prev){
        this.localValue = next;
        this.googleAddress = this.localValue.typedAddress;
    }

    @Watch('googleAddress')
    onGoogleAddressChange(next: any, prev: any){
        if (!next || typeof next !== 'object')
            return;

        const a = next as OM.Address;
        this.localValue.typedAddress = a.typedAddress ?? '';
        this.localValue.street = a.street ?? '';
        this.localValue.streetNumber = a.streetNumber ?? '';
        this.localValue.city = a.city ?? '';
        this.localValue.province = a.province ?? '';
        this.localValue.region = a.region ?? '';
        this.localValue.country = a.country ?? '';
        this.localValue.postalCode = a.postalCode ?? '';
        if (a.latLong) {
            this.localValue.latLong.lat = a.latLong.lat;
            this.localValue.latLong.lng = a.latLong.lng;
        }

        this.googleAddress = a.typedAddress;
    }

}

</script>
